export default __webpack_public_path__ + "static/media/noytrall_logo.6a43281b.svg";